export const environment = {
  mode: 'ibextouch',
  type: 'production',
  production: true,
  backendUrl: 'https://adminapi-staging.ibexfusion.com',
  messengerUrl: 'https://messengerx.ibexfusion.com',
  serverPublicKey: 'j9T7wydRYzkK9nkAbsg1OmjHotvo5FWjQWE1h9SSxlQ=',
  imageAssetPath: 'https://s3.eu-central-1.amazonaws.com/tweebie-staging/assets/images/',
  developOnLive: {
    backendUrl: 'https://adminapi-staging.ibexfusion.com',
    messengerUrl: 'https://messengerx.ibexfusion.com'
  }
};

/* development on live should not be enabled in production - but if it is, it will use the same urls ! */
